<template>
  <!-- 组合搜索组件 -->
  <div class="CombinatorialSearch">
    <div class="obj-label">
        {{t('组合条件')}}:
    </div>
    <div class="obj" v-for="(option, index) in combinatorials" :key="index">

      <div class="combinatorials">
        <Select
        :filterable="true"
          v-model="option.condition.value"
          @on-change="value => combinatorialsChange(value, option)"
        >
          <Option
            v-for="(item, index) in option.condition.list"
            :key="index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>

      <div class="relation">
        <Select v-model="option.relation.value">
          <Option
            v-for="(item, index) in option.relation.list"
            :key="index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
      </div>

      <div class="value">
        <Input
          v-if="option.value.type == 'Input'"
          v-model="option.value.value"
        ></Input>
        <Select
          v-if="option.value.type == 'Select'"
          v-model="option.value.value"
          :placeholder="t('请选择')"
          :multiple="selMultiple"
          :clearable="selMultiple"
        >
          <Option
            v-for="(item, index) in option.value.list"
            :key="index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Select
          v-if="option.value.type == 'SelectSearch'"
          v-model="option.value.value"
          filterable
          :placeholder="t('请选择')"
          :clearable="selMultiple"
        >
          <Option
            v-for="item in option.value.searchList"
            :key="item.ECODE"
            :value="item.ECODE+','+item.REGIONTYPE"
            >{{ item.ENAME }}</Option
          >
        </Select>
        <!-- <el-select v-if="option.value.type == 'SelectSearch'" v-model="option.value.value" filterable placeholder="请选择">
          <el-option
            v-for="item in option.value.searchList"
            :key="item.ECODE"
            :label="item.ENAME"
            :lType="item.REGIONTYPE"
            :value="item.ECODE+','+item.REGIONTYPE">
          </el-option>
        </el-select> -->
          <!-- v-if="/date/.test(options.value.type.toLocaleLowerCase())" -->
        <DatePicker
          v-if="['datetimerange', 'date', 'datetime', 'daterange'].includes(option.value.type)"
          :type="option.value.type"
          split-panels
          :placeholder="t('请选择')"
          :transfer="true"
          v-model="option.value.value"
        ></DatePicker>
      </div>

      <div class="group">
        <Select
          v-model="option.group.value"
          v-if="combinatorials.length !== index + 1"
        >
          <Option
            v-for="(item, index) in option.group.list"
            :key="index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <div class="addOrSub" v-if="combinatorials.length == index + 1">
          <Icon type="md-add" @click="add" />
          <Icon
            type="md-remove"
            v-if="combinatorials.length > 2"
            @click="sub"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CombinatorialSearch",
  mounted() {
    this.init(this.combinatorialSearchData);
    window.addEventListener('keyup', this.keyEvent)
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyEvent)
  },
  watch: {
    combinatorialSearchData(newValue, oldValue) {
      let _that = this;
      setTimeout(function(){
        _that.combinatorialSearchData = newValue;
        _that.init(newValue);
      },500);
    },
    deep: true
  },
  props: {
    combinatorialSearchData: {
      type: Array,
      default: []
    },
    calcSymbol: {
      type: Array,
      default: []
    },
    type: {
      //0为订单查询,1为明细查询
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selMultiple:true,
      conditionList: [], //条件列表
      combinatorials: this.getDefaultCombinatorials()
    };
  },
  methods: {
    keyEvent(e) {
      if (e.keyCode == '13') {
        this.$parent.loadData()
      }
    },
    clearData() {
      this.init(this.combinatorialSearchData);
    },
    getDefaultCombinatorials() {
      return [
        //数据结构
        {
          condition: {
            //条件
            value: "",
            list: []
          },
          relation: {
            //关系
            value: "",
            list: this.calcSymbol
          },
          value: {
            //条件值
            value: "",
            list: [
              {
                label: "a",
                value: "1"
              },
              {
                label: "b",
                value: "2"
              }
            ],
            type: "Input" //input select
          },
          group: {
            //组合条件
            value: "or",
            list: [
              {
                label: t("且"),
                value: "and"
              },
              {
                label: t("或"),
                value: "or"
              }
            ]
          }
        },
        {
          condition: {
            value: "",
            list: []
          },
          relation: {
            value: "",
            list: this.calcSymbol
          },
          value: {
            value: "",
            list: [],
            type: "Input" //input select
          },
          group: {
            value: "or",
            list: [
              {
                label: t("且"),
                value: "and"
              },
              {
                label: t("或"),
                value: "or"
              }
            ]
          }
        }
      ];
    },
    combinatorialsChange(val, opt) {
      //根据选中条件,更新条件值控件类型
      if (val !== undefined) {
        opt.value.value="";
        if(val == "BUYER_ADDR-SelectSearch"){
          opt.value.type = (val || "").split("-")[1];
          opt.value.list = this.conditionList.filter(item => {
            return item.value == val;
          })[0].list;
          opt.value.searchList = this.conditionList.filter(item => {
            return item.value == val;
          })[0].searchList;
        }else{
          opt.value.type = (val || "").split("-")[1];
          opt.value.list = this.conditionList.filter(item => {
            return item.value == val;
          })[0].list;
        }
      }
    },
    async init(data) {
      //初始化数据
      let arr = [];
      await data.map(item => {
        let obj = {};
        obj["label"] = item.displayName;
        obj["value"] = item.queryName + "-" + item.type;
        /* if(item.queryName == "HAS_TAG"){
          obj["list"] = [{"value":"合","label":"合"},{"value":"拆","label":"拆"},{"value":"挂","label":"挂"},{"value":"退","label":"退"},{"value":"赠","label":"赠"},{"value":"换","label":"换"},{"value":"手","label":"手"},{"value":"预","label":"预"},{"value":"组","label":"组"},{"value":"虚","label":"虚"},{"value":"锁","label":"锁"},{"value":"标","label":"标"},{"value":"爆","label":"爆"},{"value":"时","label":"时"},{"value":"F","label":"F"}];
        }else{ */
          obj["list"] = item.list;
        // }
        obj["searchList"] = item.value;
        obj["tableLevel"] = item.tableLevel;
        arr.push(obj);
      });
      this.conditionList = arr;
      this.combinatorials = this.getDefaultCombinatorials();
      this.combinatorials[0].condition = {
        list: arr,
        value: ""
      };
      this.combinatorials[1].condition = {
        list: arr,
        value: ""
      };
    },
    add() {
      //新增组合
      let obj = {
        condition: {
          //条件
          value: "",
          list: this.conditionList
        },
        relation: {
          //关系
          value: "",
          list: this.calcSymbol
        },
        value: {
          //条件值
          value: "",
          list: [
            {
              label: "a",
              value: "1"
            },
            {
              label: "b",
              value: "2"
            }
          ],
          type: "Input" //input select
        },
        group: {
          //组合条件
          value: "or",
          list: [
            {
              label: t("且"),
              value: "and"
            },
            {
              label: t("或"),
              value: "or"
            }
          ]
        }
      };
      this.combinatorials.push(JSON.parse(JSON.stringify(obj)));
      this.combinatorials.push(JSON.parse(JSON.stringify(obj)));
    },
    sub() {
      //删除组合
      this.combinatorials.pop();
      this.combinatorials.pop();
    },
    searchData() {
      //最后搜索条件整合
      let arr = [];
      let self = this;
      this.combinatorials.map(item => {
        const [queryName, type] = (item.condition.value || "").split("-")
        let obj = {
          type,
          queryName,
          value: ''
        };
        if (item.condition.value) {
          obj.tableLevel = self.conditionList.find(i => item.condition.value == i.value).tableLevel;
        }
        if(obj.queryName == "BUYER_ADDR"){
          let [value, REGIONTYPE] = (item.value.value || '').split(",");
          obj.value = value;
          obj.REGIONTYPE = REGIONTYPE;
        }else{
          const queryVal = item.value.value
          if(obj.queryName == "LABEL_CONDITION"){
            if(queryVal[0] == "bSelect-all"){
              obj.value = item.value.list.map(i => i.value).join(",");
            }else{
              obj.value = queryVal.join(",");
            }
          } else if (obj.type && /date/.test(obj.type.toLocaleLowerCase()) && queryVal) {
            let format = /time/.test(obj.type) ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
            if (Object.prototype.toString.call(queryVal) == '[object Date]') {
              obj.value = $utils.getFormatDate(queryVal, format)
            } else if (Array.isArray(queryVal)) {
              obj.value = queryVal.map(i => $utils.getFormatDate(i, format)).join('~')
            }
          } else {
            obj.value = queryVal;
            if (["PS_C_SKU_ECODE", "PS_C_SKU_PT_ECODE"].includes(obj.queryName)) {
              obj.value = queryVal.replaceAll('.', '')
            }
          }
        }
        obj["sign"] = item.relation.value; //关系值
        obj["rlt"] = item.group.value;
        arr.push(obj);
      });
      /* let _backlogGroupParams = sessionStorage.getItem("backlogGroupParams");
      _backlogGroupParams = _backlogGroupParams?JSON.parse(_backlogGroupParams):_backlogGroupParams;
      sessionStorage.removeItem("backlogGroupParams");
      if(_backlogGroupParams){
        setTimeout(function(){
          self.combinatorials[0]["condition"] = {
            "list":self.combinatorials[1]["condition"].list,
            "value":"LABEL_CONDITION-Select"
          }
          self.combinatorials[0]["relation"].value="ec";
          self.combinatorials[0]["value"]["type"]="Select";
          self.combinatorials[0]["value"]["list"] = [{"value":"合","label":"合"},{"value":"拆","label":"拆"},{"value":"挂","label":"挂"},{"value":"退","label":"退"},{"value":"赠","label":"赠"},{"value":"换","label":"换"},{"value":"手","label":"手"},{"value":"预","label":"预"},{"value":"组","label":"组"},{"value":"虚","label":"虚"},{"value":"锁","label":"锁"},{"value":"标","label":"标"},{"value":"爆","label":"爆"},{"value":"时","label":"时"},{"value":"F","label":"F"}];
          self.combinatorials[0]["value"]["value"] = ["手"];
        },1000);
        arr = _backlogGroupParams;
      } */
      return arr;
    }
  }
};
</script>

<style lang="less" scoped>
.CombinatorialSearch {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-left: 100px;
  position:relative;
  .obj-label {
    position:absolute;
    left:0;
    top:4px;
    display: inline-block;
    height: 26px;
    line-height: 26px;
    color: #575757;
    width: 100px;
    padding-right: 5px;
    text-align: right;
  }
  .obj {
    // margin-left: 100px;
    padding: 6px 0;
    display: flex;
    width: calc(50% - 0px);
    .combinatorials {
      flex: 3;
      // padding: 0 3px;
    }

    .relation {
      flex: 1;
      padding: 0 3px;
    }

    .value {
      flex: 3;
      padding: 0 3px;
    }

    .group {
      flex: 1;
      padding: 0 3px;
      .addOrSub {
        display: flex;
        // justify-content: flex-end;
        align-items: center;
        font-size: 26px;
        height: 100%;
        color: #fd6442;
        font-weight: 800;
        .iconfont {
          font-size: 23px;
        }
      }
    }
  }
}
</style>
